export default __webpack_public_path__ + "resources/images/favourites_pin.png";